var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 为navbar组件右侧内容占位，如登录，用户名等
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { classPrefix } from '../../common/util';

import './Navbar.less';

/*
 *  参数说明
 *
 */

var NavbarAddition = function (_Component) {
    _inherits(NavbarAddition, _Component);

    function NavbarAddition(props) {
        _classCallCheck(this, NavbarAddition);

        var _this = _possibleConstructorReturn(this, (NavbarAddition.__proto__ || Object.getPrototypeOf(NavbarAddition)).call(this, props));

        _this.state = {
            children: props.children
        };
        return _this;
    }

    _createClass(NavbarAddition, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            if ('children' in newProps) {
                this.setState({
                    children: newProps.children
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix,
                attributes = _objectWithoutProperties(_props, ['className', 'classPrefix']);

            var children = this.state.children;
            var cx = classnames(className, _defineProperty({}, classPrefix + '-navbar-addition', true));

            return React.createElement(
                'div',
                _extends({ className: cx }, attributes),
                children
            );
        }
    }]);

    return NavbarAddition;
}(Component);

NavbarAddition.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    children: PropTypes.node
};
NavbarAddition.defaultProps = {
    classPrefix: classPrefix
};
export default NavbarAddition;